<div class="network-status-banner" *ngIf=" (online$ | async) === false">
  <ion-icon name="warning-outline"></ion-icon> No Internet Connection
</div>